import {Component, OnDestroy, OnInit} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {Subject} from 'rxjs';
import {OrbitaxExcelMemoService} from '../../orbitax-excel-memo.service';
import { IPlatformToolComponent, IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { PlatformCommandResponse } from '@shared/commands/command-base';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';

@Component({
    standalone: false,
    selector: 'particle-view-memo',
  templateUrl: './view-memo.component.html',
  styleUrls: ['./view-memo.component.scss']
})
export class ViewMemoPlatformComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  unsubscribe$ = new Subject<void>();
  id: string;
  memoHtml: string = '';
  private memoType: string;

  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  invalidateSubject: InvalidateSubject;

  constructor(private excelMemoService: OrbitaxExcelMemoService,
              private activatedRoute: ActivatedRoute,
              private fuseSplashScreenService: FuseSplashScreenService,
              private router: Router) {
  }

  onLoad() {
    this.id = this.selectedTab.tabData['MemoId'];
    this.memoType = this.selectedTab.tabData['MemoType'];
    this.fuseSplashScreenService.show();
    this.excelMemoService.viewMemo(this.id, this.memoType).subscribe(o => {
      this.fuseSplashScreenService.hide();
      this.memoHtml = o;
    });
    //this.memoHtml = this.selectedTab.tabData['MemoView'];
  }
  onBeforeExecuteNextCommand(): boolean {
    throw new Error('Method not implemented.');
  }
  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
    throw new Error('Method not implemented.');
  }
  onBeforeExecutePreviousCommand(): boolean {
    throw new Error('Method not implemented.');
  }
  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
    throw new Error('Method not implemented.');
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  done() {
    if (this.isExcelMemo(this.memoType)) {
      this.router.navigateByUrl(`planning/${this.memoType}`);
    } else {
      this.router.navigateByUrl(`rate-memo/${this.memoType}`);
    }
  }
  isExcelMemo(memoType: string) {
    return (memoType === 'IPC' || memoType === 'TPRatio' || memoType === 'ThinCap' || memoType === 'NOL');
  }
}
